import { Alert, Button, Col, Form, Input, notification, Row, Select, Typography } from 'antd'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { Can } from '../../../../components'
import { handleBackendError } from '../../../../utils'

import { updateStoreLink } from '../../api'

const { Paragraph } = Typography
const { TextArea } = Input

const Home = ({ countries, form, hasWiseId, initialValues, isUpdate, retailers }) => {
  const [link, setLink] = useState('')

  const isViewMode = !initialValues.active

  const generateStoreLink = () => {
    const basename = window.location.host.split('.')[0] === 'admin' ? '' : '/admin'

    updateStoreLink(initialValues.id)
      .then(({ data }) => {
        setLink(`${window.location.origin}${basename}/new-store/${data.data.edit_url_param}`)
      })
      .catch((error) => {
        const errorMessage = handleBackendError(error)
        notification.error({
          description: errorMessage,
          message: 'Error',
        })
      })
  }

  return (
    <Row style={{ margin: 15 }}>
      <Col span={16}>
        {!isEmpty(link) && (
          <Alert
            data-testid="linkCard"
            message={
              <Paragraph copyable style={{ margin: 0 }}>
                {link}
              </Paragraph>
            }
            showIcon
            type="info"
          />
        )}
      </Col>

      <Col span={8}>
        {!hasWiseId && (
          <Col
            style={{
              textAlign: 'right',
            }}
          >
            <Can
              key="storeLink"
              requiredPermission="store.post.create"
              yes={() => (
                <Button
                  data-testid="generateNewLink"
                  disabled={!isUpdate}
                  key="submit"
                  name="createNewStoreWithLinkSelenium"
                  onClick={generateStoreLink}
                  type="link"
                >
                  Generate new store form link
                </Button>
              )}
            />
          </Col>
        )}
      </Col>

      <Col span={11}>
        <Form.Item label="Country" name="country_id" rules={[{ message: 'Please select a country!', required: true }]}>
          <Select
            data-testid="countrySelect"
            disabled={isViewMode || isUpdate}
            filterOption={(input, option) => String(option.label).toLowerCase().indexOf(input.toLowerCase()) >= 0}
            onChange={() => {
              form.setFieldsValue({ tds_store_id: null })
            }}
            options={countries.map(({ text, value }) => ({ label: text, value }))}
            showSearch
          />
        </Form.Item>
      </Col>

      <Col offset={2} span={11}>
        <Form.Item label="ID" name="id">
          <Input disabled />
        </Form.Item>
      </Col>

      <Col span={11}>
        <Form.Item
          label="Retailer"
          name="retailer_id"
          rules={[{ message: 'Please select a Retailer!', required: true }]}
        >
          <Select
            data-testid="retailerSelect"
            filterOption={(input, option) => String(option.label).toLowerCase().includes(input.toLowerCase())}
            options={retailers.map(({ name, id }) => ({ label: name, value: id }))}
            showSearch
          />
        </Form.Item>
      </Col>

      <Col offset={2} span={11}>
        <Form.Item label="Ownership Model" name="ownership_model" rules={[{ message: 'Please select an ownership model!', required: true }]}>
          <Select data-testid="ownershipModelSelect" options={[{ label: 'Corporate', value: 'corporate' }, { label: 'Franchise', value: 'franchise' }]} />
        </Form.Item>
      </Col>

      <Col span={11}>
        <Form.Item label="Status" name="active" rules={[{ message: 'Please select a status!', required: true }]}>
          <Select options={[{ label: 'Active', value: true }, { label: 'Inactive', value: false }]} />
        </Form.Item>
      </Col>

      <Col span={24}>
        <Form.Item label="Comment" name="comment">
          <TextArea disabled={isViewMode} />
        </Form.Item>
      </Col>
    </Row>
  )
}

Home.propTypes = {
  countries: PropTypes.array,
  form: PropTypes.object,
  hasWiseId: PropTypes.bool,
  initialValues: PropTypes.object,
  isUpdate: PropTypes.bool,
  retailers: PropTypes.array,
}

export default Home
